<template>
  <div>
    <v-card>
      <v-card-title v-if="this.formaction == 'create'">
        <span class="headline">Add Lookup</span>
      </v-card-title>
      <v-card-title v-if="this.formaction == 'edit'">
        <span class="headline">Edit Lookup</span>
      </v-card-title>
      <v-card-text>
        
        <small>*indicates required field</small>
        <v-container grid-list-md>
          <v-layout wrap>
           
            <v-flex xs6>
              <v-text-field
                v-model="Form.text"
                v-validate="'required|max:50'"
                data-vv-rules="required|max:50"
                data-vv-scope="lookupForm"
                :error-messages="errors.collect('lookupForm.text')"
                hide-details
                :counter="50"
                label="Text*"
                name="text"
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="Form.value"
                v-validate="'required|max:45'"
                data-vv-rules="required|max:45"
                data-vv-scope="lookupForm"
                :error-messages="errors.collect('lookupForm.value')"
                hide-details
                :counter="45"
                label="Value*"
                name="value"
              />
            </v-flex>
             <v-flex xs12>
              <v-select
                v-model="Form.portalID"
                :items="portallist"
                item-text="portalName"
                item-value="id"
                chips
                multiple
                label="Portals"
              />
            </v-flex>
            <v-flex xs6>
              <v-select
                v-model="Form.type"
                v-validate="'required'"
                :items="lookupList('type')"
                data-vv-rules="required"
                data-vv-scope="lookupForm"
                :error-messages="errors.collect('lookupForm.type')"
                hide-details
                item-text="text"
                item-value="value"
                label="Type*"
                name="type"
              ></v-select>
            </v-flex>
            
           
             <v-flex xs6>
              <v-select
                v-model="Form.lookup"
                v-validate="'required'"
                :items="lookupList('lookup')"
                data-vv-rules="required"
                data-vv-scope="lookupForm"
                :error-messages="errors.collect('lookupForm.lookup')"
                hide-details
                item-text="text"
                item-value="value"
                label="Lookup*"
                name="lookup"
              ></v-select>
            </v-flex> 
              <v-flex xs6>
              <v-text-field
                v-model="Form.order"
                hide-details
                :counter="50"
                label="Order"
                name="order"
              />
            </v-flex> 
            <v-flex xs6>
              <v-text-field v-model="Form.icon" label="Icon" name="Icon"/>
            </v-flex>        
            <v-flex xs6>
              <v-text-field
                v-model="Form.shortcutKey"                
                hide-details
                :counter="50"
                label="Shortcut Key"
                name="shortcutKey"
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="Form.lookupAction"                
                hide-details
                :counter="50"
                label="Lookup Action"
                name="lookupAction"
              />
            </v-flex>
            <v-flex xs4 text-xs-center>
              <v-icon
                v-if="Form.icon !== null || Form.icon !== undefined"
                style="font-size: 100px !important;"
              >{{ Form.icon }}</v-icon>
            </v-flex>
           
            <v-flex xs12 class="input-container">
              <span v-if="Form.enabled" style="padding-top: 25px;">Enabled</span>
              <span v-else style="padding-top: 25px;">Disabled</span>
              <v-switch v-model="Form.enabled" style="padding-left: 15px;"></v-switch>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="CloseDialog()">Close</v-btn>
        <v-btn color="blue darken-1" flat @click.native="SaveDocument('lookupForm')">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    admin: {
      type: Object,
      default() {
        return {};
      }
    },
    portal: {
      type: Object,
      default() {
        return {};
      }
    },
    form: {
      type: Object,
      default() {
        return {};
      }
    },
    formaction: {
      type: String,
      default: ""
    },
    portallist: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data: () => ({
    Form: {
      id: null,
      portalID: [],
      enabled: false,
      text: null,
      value: null,
      type: null,
      order: null,
      lookup: null,
      action: null,
      shortcutKey: null,
      lookupAction: null
    }
  }),
  computed: {
    ...mapGetters({
      lookupList: "portal/lookupList",
      lookupListField: "portal/lookupListField"
    })
  },
  mounted() {
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
  },
  watch: {
    form() {
      this.Form = this.form;
    }
  },
  methods: {
    CloseDialog() {
      this.$emit("Dialog", false);
    },
    SaveDocument(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (!valid) {
          // do nothing
        } else {
          //console.log("Save Document + " + this.formaction);
          switch (this.formaction) {
            case "create":
              this.$store.dispatch("Admin/createDocument", [
                this.admin.Collection,
                this.Form,
                "Admin/setDocumentResult"
              ]);
              break;
            case "edit":
              var id = this.Form.id;
              //console.log(JSON.stringify(this.Form, null, 2));
              this.Form = this.$omit(this.Form, [
                "vgt_id",
                "originalIndex",
                "id"
              ]);
              //console.log(JSON.stringify(this.Form, null, 2));
              this.$store.dispatch("Admin/updateDocument", [
                this.admin.Collection,
                id,
                this.Form
              ]);
              break;
            default:
              break;
          }
          this.CloseDialog();
        }
      });
    }
  }
};
</script>

<style>
.input-container {
  vertical-align: middle !important;
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}
</style>
